export const returnNonNull = <T>(item: T): item is NonNullable<T> => item !== null;

export type ArrayElement<ArrayType extends readonly unknown[]> =
	ArrayType extends readonly (infer ElementType)[] ? ElementType : never;
